import { useState } from 'react';
import { withNamespaces } from 'react-i18next';
import { connect } from 'react-redux';
import { Col, Row, Label, Card, Progress} from 'reactstrap';
import { Link } from 'react-router-dom';
import Dropzone from 'react-dropzone';
import { toast } from "react-toastify";
import axios from 'axios';
import { AI_ONBOARDING_BASE_URL } from '../../../../../../constants';
import ExcelFileSVG from '../../../../../../assets/images/ai-onboarding/excel-file.svg'

const FileUploader = ({
    t,
    title,
    className,
    token,
    fileType,
    onNewFileUploaded,
    prevFiles
}) => {

    const [uploadedFiles, setUploadedFiles] = useState(prevFiles ? prevFiles : []);

    const onUploadProgress = (e, file, setUploadedFiles) => {
        const {
            total,
            loaded,
            lengthComputable
        } = e;

        if(lengthComputable){
            const uploadedPercent = loaded / total * 100;

            setUploadedFiles((uploadedFiles) => {
                const index = uploadedFiles.findIndex((f) => f.preview === file.preview);

                if(index > -1){
                    uploadedFiles[index].uploadedPercent = uploadedPercent;

                    return [
                        ...uploadedFiles
                    ]
                }

                return [
                    ...uploadedFiles
                ]
            });
        }
    }

    const handleAcceptedFiles = (files) => {
        const headers = {
            headers : {
                Authorization: `Bearer ${token}`
            },
            onUploadProgress : null
        };

        files.map((file) => {
            const formData = new FormData();

            formData.append('file', file);
            formData.append('fileType', fileType)

            file = {
                ...file,
                status          :   'uploading',
                name            :   file.name,
                type            :   file.type,
                uploadedPercent :   0,
                preview         :   URL.createObjectURL(file),
                formattedSize   :   file.size
            }

            setUploadedFiles([
                {...file}
            ]);

            axios.post(`${AI_ONBOARDING_BASE_URL}/onboarding/file/upload`, formData, {
                ...headers,
                onUploadProgress : (e) => {
                    onUploadProgress(e, file, setUploadedFiles);
                }
            })
            .then((response) => {
                setUploadedFiles((uploadedFiles) => {
                    const index = uploadedFiles.findIndex((f) => f.preview === file.preview);
    
                    if(index > -1){
                        if (response.status === 200) {
                            const fileData = response.data.data;

                            uploadedFiles[index].status = 'upload_succeed';

                            uploadedFiles[index].id = fileData?.id;

                            onNewFileUploaded && onNewFileUploaded(fileType, uploadedFiles[index]);
                        }
                        else{
                            uploadedFiles[index].status = 'upload_failed';
                        }
    
                        return [
                            ...uploadedFiles
                        ]
                    }
    
                    return [
                        ...uploadedFiles
                    ]
                });
            })
            .catch((error) => {
                setUploadedFiles((uploadedFiles) => {
                    const index = uploadedFiles.findIndex((f) => f.preview === file.preview);
    
                    if(index > -1){
                        uploadedFiles[index].status = 'upload_failed';
    
                        return [
                            ...uploadedFiles
                        ]
                    }
    
                    return [
                        ...uploadedFiles
                    ];
                });

                toast(t(error.response.data.message), {
                    type: 'error'
                });
            });
        });
    };

    return (
        <div className={`ai-onboarding-file-uploader ${className}`}>
            {title && (
                <Label className="form-label">
                    {t(title)}
                </Label>
            )}
            
            <div>
                <Dropzone
                    onDrop={handleAcceptedFiles}
                    multiple={false}
                    accept=".xlsx,.xls,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
                    maxFiles={1}
                >
                {({
                    getRootProps,
                    getInputProps
                }) => (
                    <div className="dropzone tpdd p-3">
                        <div
                            className="dz-message needsclick"
                            {...getRootProps()}>
                            <input {...getInputProps()} />
                            <button type="button" className="btn btn-outline">
                                {t('Select file...')}
                            </button>
                            <h4>
                                {t(
                                    "Drop file here or click to upload"
                                )}
                            </h4>
                        </div>
                        
                    </div>
                )}
                </Dropzone>
            </div>
            <div className="dropzone-previews tpdd">
                {uploadedFiles.map(
                    (f, i) => {
                        return (
                            <Card className="mb-0 shadow-none dz-processing dz-image-preview dz-success dz-complete"
                                key={i + "-file"}>
                                <div className="p-3">
                                    <Row className="align-items-center">
                                        <Col className="col-auto">
                                            <img
                                                data-dz-thumbnail=""
                                                height="80"
                                                className="avatar-sm rounded bg-light"
                                                alt={f.name}
                                                src={ExcelFileSVG}
                                            />
                                        </Col>
                                        <Col>
                                            <Link
                                                to="#"
                                                className="file-name">
                                                {f.name} {f.uploaded}
                                            </Link>
                                            <p className="upload-details-container">
                                                <span className='file-size'>
                                                    {(f.formattedSize / 1024).toFixed(2)} KB
                                                </span>
                                                {
                                                    f.status === 'upload_succeed' && (
                                                        <span className="upload-status-message succeed">
                                                            {t("File(s) successfully uploaded.")}
                                                        </span>
                                                    )
                                                }
                                                {
                                                    f.status === 'upload_failed' && (
                                                        <span className="upload-status-message failed">
                                                            {t("File(s) failed to upload.")}
                                                        </span>
                                                    )
                                                }
                                            </p>
                                        </Col>
                                        <Col xs={2} className="actions-container">
                                            {
                                                f.status === 'uploading' && (
                                                    <span className="uploaded-percent">
                                                        { Math.ceil(f.uploadedPercent) }%
                                                    </span>
                                                )
                                            }
                                            
                                            {/* <button type="button" className="btn">
                                                {
                                                    (f.status === 'uploading' || f.status === 'deleting') ? (
                                                        <i className="ri-forbid-line font-size-20"></i>
                                                    ) : (
                                                        <i className="ri-close-line font-size-20"></i>
                                                    )
                                                }
                                            </button> */}
                                        </Col>
                                    </Row>
                                </div>
                                {
                                    f.status === 'uploading' && (
                                        <Progress value={ Math.ceil(f.uploadedPercent) } />
                                    )
                                }
                            </Card>
                        );
                    }
                )}
            </div>
        </div>
	);
}

const mapStatetoProps = (state) => {
    const { token } = state.Login;
    return {
        token         :   token
    };
};

export default withNamespaces()(
    connect(
        mapStatetoProps,
        {}
    )(FileUploader)
)